import { LogIn, ShieldAlert } from 'lucide-react';
import Logo from './Logo.jsx';
import { loginUrl } from '../api/client.js';

/**
 * Écran d'accueil non authentifié.
 *
 * Le login n'est PAS réimplémenté ici : synobatch délègue entièrement à
 * synocore, qui détient l'annuaire et pose le cookie SSO `syn_session` sur
 * `.synotis.tech`. Une session ouverte sur synolog ou synosight vaut donc
 * session ici — l'utilisateur n'aura souvent rien à saisir.
 *
 * Deux situations distinctes, à ne pas confondre pour l'utilisateur :
 *   • `anonymous` : aucune session → on propose de se connecter ;
 *   • `forbidden` : session valide mais rôle insuffisant → se reconnecter n'y
 *     changerait rien, c'est un administrateur qui doit accorder le rôle.
 */
export default function SignIn({ reason = 'anonymous' }) {
  const forbidden = reason === 'forbidden';

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bg)',
        color: 'var(--text)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          width: 'min(420px, 100%)',
          padding: 28,
          borderRadius: 'var(--radius-md)',
          background: 'var(--card-bg)',
          border: '1px solid var(--glass-border)',
          boxShadow: 'var(--shadow-card)',
          textAlign: 'center',
        }}
      >
        <Logo style={{ height: 42, width: 'auto', color: 'var(--text)' }} />

        <p style={{ margin: '18px 0 6px', fontSize: 14, color: 'var(--text-muted)' }}>
          Console de suivi des batchs de l'écosystème Synotis
        </p>

        {forbidden ? (
          <>
            <div
              style={{
                display: 'flex',
                gap: 8,
                alignItems: 'center',
                justifyContent: 'center',
                margin: '20px 0 8px',
                color: 'var(--danger)',
              }}
            >
              <ShieldAlert size={18} />
              <strong style={{ fontSize: 15 }}>Accès réservé aux administrateurs</strong>
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.5, margin: 0 }}>
              Votre compte est bien authentifié, mais ne dispose pas du rôle nécessaire.
              Demandez à un administrateur de l'écosystème de vous l'accorder.
            </p>
          </>
        ) : (
          <>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.5 }}>
              Connectez-vous avec votre compte Synotis. L'authentification est assurée par
              l'écosystème : si vous êtes déjà connecté à Synolog ou Synosight, l'accès
              sera immédiat.
            </p>
            <a
              href={loginUrl(window.location.pathname)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                marginTop: 18,
                padding: '10px 20px',
                borderRadius: 'var(--radius-sm)',
                background: 'var(--brand)',
                color: '#fff',
                fontWeight: 600,
                fontSize: 14,
                textDecoration: 'none',
              }}
            >
              <LogIn size={16} /> Se connecter
            </a>
          </>
        )}
      </div>
    </div>
  );
}
